module.exports = __webpack_public_path__ + "img/line.56015597.png";